import { render, staticRenderFns } from "./repay.vue?vue&type=template&id=22b23b8d&scoped=true"
import script from "./repay.vue?vue&type=script&lang=js"
export * from "./repay.vue?vue&type=script&lang=js"
import style0 from "./repay.vue?vue&type=style&index=0&id=22b23b8d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b23b8d",
  null
  
)

export default component.exports